/**
 * Map swipe. Frame = this report's selected photo. Module = this report's IR footprints vs modules.
 * Site RGB ortho / rgbLayer is not a report RGB source — never put it on a swipe side.
 */

export const MAP_SWIPE_MODE_MODULE = 'module';
/** @deprecated use MAP_SWIPE_MODE_MODULE */
export const MAP_SWIPE_MODE_CATALOG = MAP_SWIPE_MODE_MODULE;
export const MAP_SWIPE_MODE_FRAME = 'frame';

export function collectModuleSwipeSides(workingLayer = {}, options = {}) {
  const moduleLayer = options.moduleLayer || null;
  const left = workingLayer.irLayer ? [workingLayer.irLayer] : [];
  const right = moduleLayer ? [moduleLayer] : [];
  return {
    left,
    right,
    canEnable: left.length > 0 && right.length > 0
  };
}

export function collectCatalogSwipeSides(workingLayer, options) {
  return collectModuleSwipeSides(workingLayer, options);
}

export function collectFrameSwipeSides(workingLayer = {}, options = {}) {
  const hasRgbImageOnMap = !!options.hasRgbImageOnMap;
  const left = workingLayer.thermalImgFeature ? [workingLayer.thermalImgFeature] : [];
  const right =
    hasRgbImageOnMap && workingLayer.rgbImg ? [workingLayer.rgbImg] : [];
  return {
    left,
    right,
    canEnable: left.length > 0 && right.length > 0
  };
}

export function collectMapSwipeSides(workingLayer, mode, options = {}) {
  if (mode === MAP_SWIPE_MODE_FRAME) {
    return collectFrameSwipeSides(workingLayer, options);
  }
  if (mode === MAP_SWIPE_MODE_MODULE) {
    return collectModuleSwipeSides(workingLayer, options);
  }
  return { left: [], right: [], canEnable: false };
}
